import LockOpen from "@mui/icons-material/LockOpen";
import { IconButtonProps } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppToolButton } from "ui/Scripts/source/components/framework/Button/AppToolButton";

export const UnlockToolButton = (props: IconButtonProps) => (
    <AppToolButton
        {...props}
        tooltip={Translations.Unlock}
        icon={<LockOpen color="warning" />}
    />
);
